import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { AuthLayout } from "../../components/AuthLayout";
import { api } from "../../lib/api";
import { ErrorMessage } from "../../components/ErrorMessage";
import { Field } from "../../components/Field";

function friendly(message) {
  return String(message || "Something went wrong.").replace(/^\d{3}\s+/, "");
}

const MIN_PASSWORD = 8;

export function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setError(null);
    if (password.length < MIN_PASSWORD) {
      setError(`Password must be at least ${MIN_PASSWORD} characters.`);
      return;
    }
    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }
    setBusy(true);
    try {
      await api.resetPassword({ token, new_password: password });
      setDone(true);
    } catch (err) {
      setError(friendly(err.message));
      setBusy(false);
    }
  }

  // A reset link without a token is unusable — say so plainly.
  if (!token) {
    return (
      <AuthLayout
        title="Reset your password"
        footer={
          <span>
            <Link to="/forgot-password">Request a new link</Link>
          </span>
        }
      >
        <ErrorMessage message="This reset link is missing its token. Request a fresh one." />
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      title="Choose a new password"
      footer={
        done ? undefined : (
          <span>
            <Link to="/login">Back to sign in</Link>
          </span>
        )
      }
    >
      {done ? (
        <div className="auth-msg" role="status">
          Your password has been reset.{" "}
          <Link to="/login">Sign in with your new password.</Link>
        </div>
      ) : (
        <form className="auth-form" onSubmit={onSubmit}>
          <ErrorMessage message={error} />

          <Field variant="auth" label="New password">
            <input
              type="password"
              className="input"
              autoComplete="new-password"
              required
              minLength={MIN_PASSWORD}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <span className="auth-hint">At least {MIN_PASSWORD} characters.</span>
          </Field>

          <Field variant="auth" label="Confirm new password">
            <input
              type="password"
              className="input"
              autoComplete="new-password"
              required
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
            />
          </Field>

          <button type="submit" className="btn primary auth-submit" disabled={busy}>
            {busy ? "Resetting…" : "Reset password"}
          </button>
        </form>
      )}
    </AuthLayout>
  );
}
